import { axiosClient as axios } from './axiosClient';

import { api } from '@config/apiEndpoints';
import { ResultViewModel } from '@models/common/ResultViewModel';
import {
  DashboardInvoiceStatsResultViewModel,
  DashboardInvoiceMonthlyStatsResultViewModel,
  DashboardSummaryStatsResultViewModel,
} from '@models/Dashboard';
import { handleAxiosError } from '@utils/axiosErrorHandler';

export const DashboardService = {
  getSummaryStats: async function (): Promise<
    DashboardSummaryStatsResultViewModel | ResultViewModel
  > {
    const dataUrl = `${api.BASE_URL}${api.DASHBOARD_ENDPOINT}/summary-stats`;
    try {
      const response = await axios.get(dataUrl);
      return response.data as DashboardSummaryStatsResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getInvoiceStats: async function (): Promise<
    DashboardInvoiceStatsResultViewModel | ResultViewModel
  > {
    const dataUrl = `${api.BASE_URL}${api.DASHBOARD_ENDPOINT}/invoice-stats`;
    try {
      const response = await axios.get(dataUrl);
      return response.data as DashboardInvoiceStatsResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getInvoiceMonthlyStats: async function (): Promise<
    DashboardInvoiceMonthlyStatsResultViewModel | ResultViewModel
  > {
    const dataUrl = `${api.BASE_URL}${api.DASHBOARD_ENDPOINT}/invoice-monthly-stats`;
    try {
      const response = await axios.get(dataUrl);
      return response.data as DashboardInvoiceMonthlyStatsResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
};
